import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("iframe", {
  title: "Feedback Form",
  class: "freshwidget-embedded-form",
  id: "freshwidget-embedded-form",
  src: "https://help.myhealthaccess.ca/widgets/feedback_widget/new?&widgetType=embedded&submitTitle=Submit+Request&screenshot=No&searchArea=no&captcha=yes",
  scrolling: "no",
  height: "500px",
  width: "100%",
  frameborder: "0"
}, "\n\t\t\t", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_PageWrapper = _resolveComponent("PageWrapper")!

  return (_openBlock(), _createBlock(_component_PageWrapper, { contentWidthFull: "" }, {
    "content-header": _withCtx(() => [
      _createVNode(_component_ModalHeader, {
        "header-text": this.$mhat('ContactSupportModal.HeaderText')
      }, null, 8, ["header-text"])
    ]),
    "content-top": _withCtx(() => [
      _hoisted_1
    ]),
    "content-bottom": _withCtx(() => []),
    _: 1
  }))
}